import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img06.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Top-Rated Mobile App Development Company in Indianapolis</h2>
            <p>
              Today, TekRevol has become one of the most credible mobile app
              development companies in Indianapolis due to its revolutionary
              approach toward advancement in mobile app solutions. By choosing
              us, you can unlock an opportunity for sustainable growth in this
              digital market, where your app is more than just a tool, ensuring
              a solid brand image that speaks for itself.
            </p>
            <p>
              The professionals in our Indianapolis app development company
              understand that the diverse requirements of different businesses
              based on their experience. With our deep understanding of
              technology and business, we'll help you identify the areas of
              improvement, enhance workflows, and implement solutions that
              optimize your operations. As a result, we enhance the business
              productivity with profitability based on automated processes and
              efficient systems integration in our app development services.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
